/* eslint-disable no-unused-vars */

import { useState, useContext, useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { __RouterContext } from 'react-router'

import { getQueryStrings } from 'utils/querystrings'
import { getStorage } from 'utils/localstorage'
import axios from 'utils/axios/modules/notice'

async function requestNotice(id, setIsNoticeRequestingAPI, setNotice, setNoticeErrors) {
  setIsNoticeRequestingAPI(true)

  await axios
    .getNotice(id)
    .then((response) => {
      setNotice(response)
    })
    .catch((errorMessages) => {
      setNoticeErrors(errorMessages)
    })

  setIsNoticeRequestingAPI(false)
}

async function requestNotices(setIsNoticesRequestingAPI, setNotices, setNoticesErrors, page = 1, per_page = 10) {
  setIsNoticesRequestingAPI(true)

  await axios
    .getNotices(page, per_page)
    .then((response) => {
      setNotices(response)
    })
    .catch((errorMessages) => {
      setNoticesErrors(errorMessages)
    })

  setIsNoticesRequestingAPI(false)
}

function useNewsHook() {
  const { id } = useParams()
  const name = getStorage('lastname') + '　' + getStorage('firstname')

  const params = getQueryStrings(useContext(__RouterContext))
  const page = params.page !== undefined ? params.page : 1

  const newsInfos = {
    1: {
      title: 'クレジットカード情報変更のお願い',
      msg: `本日は、ご登録のクレジットカード有効期限が近づいてまいりましたので、ご案内申し上げます。

新しいクレジットカードがお手元に届きましたら、マイページよりクレジットカード情報変更のお手続きをお願いいたします。

！注意！
複数契約されている場合は、それぞれのご契約に対してクレジットカード情報変更手続きが必要です。
お手数ですが、ご確認をお願いいたします。

また、万が一、情報変更が間に合わずクレジットカードの有効期限切れが発生した場合は、当社判断で以降の月額利用料に加算してご請求させていただきます。
お早めにお手続きを行っていただければ幸いです。`,
    },
    2: {
      title: 'NINAL 月会費につきましてご連絡',
      msg: `いつもメガネの田中をご利用いただきありがとうございます。

NINALサービスの月会費について、クレジット請求にて決済することが出来ませんでした。
ご登録いただいておりますクレジットカードがご利用いただけない状態になっている可能性がございます。

つきましては、下記マイページよりご利用可能なクレジットカードへのご変更をお願いいたします。

ご利用いただけない理由については、クレジット会社にお問い合わせいただければと存じますが
よくあるケースとしては「利用限度額超過」「有効期限切れ」「何らかの理由で無効化」などがあります。

なお、今回の決済エラー分は以降の月額利用料に加算してご請求させていただきます。

ご不明点等ございましたら、お手数ではございますが、下記お問い合わせ先までご連絡ください。

━━お問い合わせ先━━━━━━━━━━━━━━━━━━━━━

定額サービス（支払い）お問合せ
TEL：0120-933-359
(受付時間9:00〜18:00 日曜除く）
問い合わせ： customer_sbsc@tanaka-megane.co.jp
URL： https://www.tanaka-megane.co.jp/ninal

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`,
    },
    3: { title: 'クレジットカード情報を登録しました', msg: 'クレジットカード情報を登録しました' },
    // 4: { title: 'アカウント情報を変更しました', msg: 'アカウント情報を変更しました' },
    5: { title: '契約満了時期が近づきました', msg: '契約満了時期が近づきました' },
    6: { title: '【NINAL】契約が開始されました', msg: '【NINAL】契約が開始されました' },
    7: { title: '【NINAL】契約が満了しました', msg: '【NINAL】契約が満了しました' },
    8: {
      title: 'クレジットカードの有効期限が切れています',
      msg: `本日は、ご登録のクレジットカードが有効期限切れとなっておりますので、ご案内申し上げます。

新しいクレジットカードがお手元に届きましたら、以下のURLよりクレジットカード情報変更のお手続きをお願いいたします。

【ニナル専用マイページ ログイン】
https://mypage.tanaka-megane.co.jp/ninal/mypage/login

！注意！
複数契約されている場合は、それぞれのご契約に対してクレジットカード情報変更手続きが必要です。
お手数ですが、ご確認をお願いいたします。

なお、今回の決済エラー分は以降の月額利用料に加算してご請求させていただきます。
お早めにお手続きを行っていただければ幸いです。`,
    },
    9: {
      title: '【メガネのかけかえのご提案】',
      msg: `いつもメガネの田中をご利用いただきありがとうございます。

本メールは3年間で3本メガネをご利用いただける「NINAL」のご契約から1年以上が経過し、まだ一度もメガネの交換をされていない全てのお客様に配信しております。

 NINALは、メガネのフレーム、レンズともに、ライフスタイルの変化に合わせて「かけやえ」やすくすることを目的に提供しているサービスです。メガネの新作も定期的に入荷しておりますので、「メンテナンス」や「視力チェック」等の実施とあわせて「かけかえ」もご検討いただければ幸いです。

お客様の毎日が、メガネで少しでも明るく、カラフルなものになるお手伝いをさせていただけるよう、スタッフ一同心待ちにしております。

  ※既に交換をされているお客様に、行き違いでこのメールが届いている場合は、ご容赦ください。

ご来店時は、事前にご予約をおすすめしております。
こちらのＵＲＬより、ご予約くださいませ。
https://www.tanaka-megane.co.jp/store/

【ご予約方法】※該当の店舗をご選択いただき、以下の手順でご予約ください。

①	『来店目的を選択』からご希望の目的をクリック（選択後、チェックマークが表示されます。）
②	『予約日時を選択』に表示されている日時でご都合のよい日時をクリック（○が表示されている日時がご予約可能日時です。）
③	『予約・来店内容の確認』に【必須】と記載されている項目を入力し、「次へ進む」をクリック
④	『予約者情報入力』に【必須】と記載されている項目を入力し、「次へ進む」をクリック
⑤	 内容にお間違えがないかご確認の上「完了する」をクリック。その後入力されたメールアドレス宛に受付完了メールが送信されます。

※本メールは送信専用アドレスからお送りしておりますので、ご返信にはお答えできかねます。お問い合わせは以下にご連絡ください。

━━お問い合わせ先━━━━━━━━━━━━━━━━━━━━━

 メガネの田中 お客さま相談室
TEL：0120-455-252
(受付時間10:00～17:00 土日祝除く）
お問い合わせ：https://www.tanaka-megane.co.jp/inquiry/
メガネの田中HP： https://www.tanaka-megane.co.jp
`,
    },
    10: {
      title: '【メガネのかけかえのご提案】',
      msg: `いつもメガネの田中をご利用いただきありがとうございます。

 本メールは3年間で3本メガネをご利用いただける「NINAL」のご契約後から1年が経過し、まだ一度もメガネの交換をされていない全てのお客様に配信しております。

 NINALは、メガネのフレーム、レンズともに、ライフスタイルの変化に合わせて「かけかえ」やすくすることを目的に提供しているサービスです。メガネの新作も定期的に入荷しておりますので、「メンテナンス」や「視力チェック」等の実施とあわせて「かけかえ」もご検討いただければ幸いです。

お客様の毎日が、メガネで少しでも明るく、カラフルなものになるお手伝いをさせていただけるよう、スタッフ一同心待ちにしております。

 ※既に交換をされているお客様に、行き違いでこのメールが届いている場合は、ご容赦ください。

ご来店時は、事前にご予約をおすすめしております。
こちらのＵＲＬより、ご予約くださいませ。
https://www.tanaka-megane.co.jp/store/


【ご予約方法】※該当の店舗をご選択いただき、以下の手順でご予約ください。

①	『来店目的を選択』からご希望の目的をクリック（選択後、チェックマークが表示されます。）
②	『予約日時を選択』から表示されている日時でご都合のよい日時をクリック（○が表示されている日時がご予約可能日時です。）
③	『予約・来店内容の確認』で【必須】と記載されている項目を入力し、「次へ進む」をクリック
④	『予約者情報入力』で【必須】と記載されている項目を入力し、「次へ進む」をクリック
⑤	 内容にお間違えがないかご確認の上「完了する」をクリック。その後入力されたメールアドレス宛に受付完了メールが送信されます。

※本メールは送信専用アドレスからお送りしておりますので、ご返信にはお答えできかねます。お問い合わせは以下にご連絡ください。

━━お問い合わせ先━━━━━━━━━━━━━━━━━━━━━

メガネの田中 お客さま相談室
TEL：0120-455-252
(受付時間10:00～17:00 土日祝除く）
問い合わせ：https://www.tanaka-megane.co.jp/inquiry/
URL： https://www.tanaka-megane.co.jp
`,
    },
    11: {
      title: '【大切なお知らせ】見え方保証（6か月）のご案内',
      msg: `いつもメガネの田中をご利用いただきありがとうございます。

 本メールは、メガネをご利用後5ヵ月経過された全てのお客様に配信しております。

メガネの見え方はいかがですか？
「希望通りの見え方」、「慣れて快適」と感じていただけておりますでしょうか？

メガネの田中では、ご利用から6か月以内であれば、無料で視力変化によるレンズの度数変更が可能な「見え方保証」を提供しております。

新しいメガネを使い始めてからも、定期的に測定し、適切な見え方を維持することが重要です。見え方がしっくりこないと感じていらっしゃる場合や、急激な視力変化があった場合、またメガネの使用方法などについてもお気軽にご相談くださいませ。

※見え方保証期間のレンズ交換は、NINALのかけかえ回数には含まれません。ご安心ください。
※既に交換をされているお客様に、行き違いでこのメールが届いている場合はご容赦ください。

ご来店時は、事前にご予約をおすすめしております。
以下ＵＲＬより、ご予約くださいませ。
 https://www.tanaka-megane.co.jp/store/

【ご予約方法】※該当の店舗をご選択いただき、以下の手順でご予約ください。

①	『来店目的を選択』からご希望の目的をクリック（選択後、チェックマークが表示されます。）
②	『予約日時を選択』に表示されている日時でご都合のよい日時をクリック（○が表示されている日時がご予約可能日時です。）
③	『予約・来店内容の確認』に【必須】と記載されている項目を入力し、「次へ進む」をクリック
④	『予約者情報入力』に【必須】と記載されている項目を入力し、「次へ進む」をクリック
⑤	 内容にお間違えがないかご確認の上「完了する」をクリック。その後入力されたメールアドレス宛に受付完了メールが送信されます。

※本メールは送信専用アドレスからお送りしておりますので、ご返信にはお答えできかねます。お問い合わせは以下にご連絡ください。


━━お問い合わせ先━━━━━━━━━━━━━━━━━━━━━

 メガネの田中 お客さま相談室
TEL：0120-455-252
(受付時間10:00～17:00 土日祝除く）
お問い合わせ：https://www.tanaka-megane.co.jp/inquiry/
メガネの田中HP： https://www.tanaka-megane.co.jp
`,
    },
    12: {
      title: '【アンケートご協力のお願い】',
      msg: `いつもメガネの田中をご利用いただきありがとうございます。

NINALはサービス誕生から2年がたち、おかげさまで多くのお客様にご愛顧いただいております。今後も、皆様と共にNINALをよりご満足いただけるサービスにしていくため、ぜひご意見をお聞かせください。

所要時間1～2分の簡単なアンケートです。
アンケートをはじめるには、下記のURLをクリックしていただくか、
アドレス全体をご利用のブラウザにコピーし、検索ください。

https://forms.gle/7rdoTV7Lnfrxw8AS6
【アンケート回答期限：2021年4月19日（月）23：59】

※本メールは送信専用アドレスからお送りしておりますので、ご返信にはお答えできかねます。お問い合わせは以下にご連絡ください。
また、今後メール配信停止をご希望される場合は以下のお電話かお問い合わせフォームからご連絡ください。

━━お問い合わせ先━━━━━━━━━━━━━━━━━━━━━
 メガネの田中 お客さま相談室
TEL：0120-455-252
(受付時間10:00～17:00 土日祝除く）
お問い合わせ：https://www.tanaka-megane.co.jp/inquiry/
メガネの田中HP： https://www.tanaka-megane.co.jp
`,
    },
  }

  // notice関連
  const [notice, setNotice] = useState({})
  const [isNoticeRequestingAPI, setIsNoticeRequestingAPI] = useState(false)
  const [noticeErrors, setNoticeErrors] = useState([])
  const getNotice = useCallback(async () => {
    await requestNotice(id, setIsNoticeRequestingAPI, setNotice, setNoticeErrors)
  }, [id])

  // noticess関連
  const [notices, setNotices] = useState([])
  const [isNoticesRequestingAPI, setIsNoticesRequestingAPI] = useState(false)
  const [noticesErrors, setNoticesErrors] = useState([])
  const getNotices = useCallback(async () => {
    await requestNotices(setIsNoticesRequestingAPI, setNotices, setNoticesErrors, page)
  }, [page])

  return {
    id,
    name,
    page,
    newsInfos,

    // notice関連
    notice,
    isNoticeRequestingAPI,
    noticeErrors,
    setNoticeErrors,
    getNotice,

    // notices関連
    notices,
    isNoticesRequestingAPI,
    noticesErrors,
    setNoticesErrors,
    getNotices,
  }
}

export default useNewsHook
